import React from "react";
import LoaderForSearch from "../Common/LoaderForSearch";

function FnoDeliveryReportTable(props) {
    const { data, handleTableScroll } = props;

    return (
        <>
            <div className="table-responsive scroll-table report-table-wrapper tax-table">
                <table className="table last-column">
                    <thead>
                        <>
                            <tr className="">
                                {/* <th scope="col">Sr.No.</th> */}
                                <th scope="col">Sauda Date</th>
                                <th scope="col">Client Code</th>
                                <th scope="col">Brokerage </th>
                                <th scope="col">Exchange</th>

                            </tr>
                        </>
                    </thead>
                    <tbody onScroll={(e) => handleTableScroll(e)} id="per-table-body" style={{height:"250px"}}>
                        {data &&
                            data.map((item, key) => {
                                return (
                                    <>
                                        <tr key={key} className="">
                                            {/* <td>{key+1}</td> */}
                                            <td>{item?.saudaDate || "-"}</td>
                                            <td>{item?.partyCode || "-"}</td>
                                            <td>{item?.brokerage || 0}</td>
                                            <td>{item?.exchange || "-"}</td>

                                        </tr>
                                    </>
                                );
                            })}
                        {props.scrollLoaderTable && (
                            <div className="loader-center">
                                <LoaderForSearch />
                            </div>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
export default FnoDeliveryReportTable;
